import { matchPath } from 'react-router';
import { logger } from 'packages/logger';

export const getCurrentPageFromRoute = (routeMap, location) => {
    if (!routeMap) {
        logger(`Variable 'routeMap' missing in getCurrentPageFromRoute()`);
        return;
    } else if (!location) {
        logger(`Variable 'location' missing in getCurrentPageFromRoute()`);
        return;
    }

    const matchedPage = Object.keys(routeMap)?.find((pageName) => {
        const page = routeMap[pageName];
        return matchPath(location.pathname, {
            path: page.path,
            exact: page.exact || false,
            strict: page.strict || false
        });
    });

    return routeMap[matchedPage];
};
